import { AuthService } from '@yubi/yb-module-auth';
// import { Logger } from 'auth-library/lib/typings';
// import { logException } from './Logger';
// import { getDomainName } from './Common';

export default AuthService;
